// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"83915b0cd60aa120","5285":"0fc8a15ccd46f6ee"}[chunkId] + ".css";
};